import React from 'react'
import CustomModal from '../../../../components/mui/CustomModal'
import HighlightOffRoundedIcon from '@mui/icons-material/HighlightOffRounded';
import CustomTypography from '../../../../components/mui/CustomTypography';
import { CustomButton } from '../../../../components/mui/CustomButton';

const ReworkStatusModal = ({ open, onClose }) => {
    return (
        <CustomModal open={open} onClose={onClose} sx={{ maxWidth: '600px' }}>
            <div className="preview-dropdown-header">
                Rework Notice
                <HighlightOffRoundedIcon
                    onClick={onClose}
                    style={{ cursor: 'pointer', opacity: 0.5, height: '28px', width: '28px' }}
                />
            </div>
            <div className="preview-dropdown-body">
                <CustomTypography>
                    This file is in Rework status. You can send it to another vendor, but editing is disabled for you.
                </CustomTypography>
                <div style={{ display: 'flex', justifyContent: 'end', alignItems: 'center', gap: '10px' }}>
                    <CustomButton variant="secondary" onClick={onClose}>
                        Understood
                    </CustomButton>
                </div>
            </div>
        </CustomModal>
    )
}

export default ReworkStatusModal